"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NotFoundSection = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../..");
var copy_1 = require("./copy");
var NotFoundSection = function () {
    var _a = (0, __1.useComponents)(), Card = _a.Card, Heading1 = _a.Heading1, P = _a.P;
    var _b = (0, __1.useCopy)(copy_1.defaultOptions), Copy = _b.Copy, copy = _b.copy;
    return (react_1.default.createElement("section", { id: "not-found" },
        react_1.default.createElement(Card, null,
            react_1.default.createElement(Heading1, { "data-testid": "not-found-heading" }, copy('heading')),
            react_1.default.createElement(P, { "data-testid": "not-found-details" },
                react_1.default.createElement(Copy, { copyKey: "details" })))));
};
exports.NotFoundSection = NotFoundSection;
